<script>
  let { asset, label = 'Reference image' } = $props();
  let src = $state('');
  $effect(() => {
    const url = URL.createObjectURL(asset.blob);
    src = url;
    return () => URL.revokeObjectURL(url);
  });
</script>

<div class="reference-image-tile">
  <img {src} alt="{label}: {asset.name}" />
  <span>{asset.name}</span>
  <small>{asset.width} × {asset.height} · original dimensions</small>
</div>

<style>
  .reference-image-tile { display: grid; gap: 0.25rem; min-width: 0; }
  img { width: 100%; height: 88px; object-fit: contain; background: var(--color-bg); border-radius: 6px; }
  span { overflow-wrap: anywhere; font-size: 0.75rem; }
  small { color: var(--color-text-muted); font-size: 0.68rem; }
</style>
